import React, {useContext, useState, useEffect} from 'react';
import DataGrid from '../../../components/DataGrid';
import {DataContext} from '../../../utils/DataProvider';
import {createOrUpdateData} from '../../../utils/utils';
import {createCategoryFaq, deleteCategoryFaq, fetchCategoryFaq, updateCategoryFaq} from '../../../services/categoryFaq';

const CategoryFaq = () => {
  const {state, paginationParams, filterParams} = useContext(DataContext);
  const [data, setData] = useState(null);
  const [reset, setReset] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const ENVS = state.environment === 'dairy' ? 'DAIRY_CATTLE' : 'BEEF_CATTLE';

  useEffect(() => {
    const loadData = async () => {
      const response = await fetchCategoryFaq({
        ...paginationParams,
        ...filterParams,
        environment: ENVS,
      });
      setData(response.data.resultList);
      setTotalItems(response.data.size);
    };

    loadData();
  }, [reset, paginationParams, filterParams]);// eslint-disable-line

  const columns = [
    {
      key: 'title',
      field: 'title',
      name: 'Título',
      required: true,
      textAlign: 'Center',
      editType: 'textedit',
    },
    {
      key: 'ordenation',
      valueKey: 'ordenation',
      field: 'ordenation',
      required: true,
      name: 'Ordem',
      textAlign: 'Center',
      editType: 'numericedit',
    },
  ];

  const actions = [
    {
      title: 'Adicionar',
      action: 'add',
      icon: 'fas fa-plus',
    },
    {
      title: 'Editar',
      action: 'edit',
      icon: 'fas fa-pencil-alt',
    },
    {
      title: 'Excluir',
      action: 'remove',
      icon: 'fas fa-trash-alt',
      onClick: async (value) => {
        try {
          const response = await deleteCategoryFaq(value.id);
          setReset(!reset);
          return response;
        } catch (error) {
          console.error(error);
          return error;
        }
      },
    },
    {
      title: 'Salvar',
      action: 'save',
      icon: 'fas fa-save',
    },
    {
      title: 'Cancelar',
      action: 'cancel',
      icon: 'fas fa-times',
    },
  ];

  return (
    <>
      {data && (
        <>
          <DataGrid
            onChange={async (dataGridInputs) => {
              dataGridInputs.environment = ENVS === 'BEEF_CATTLE' ? 0 : 1;
              dataGridInputs.ordenation = +dataGridInputs.ordenation;
              const response = await createOrUpdateData(dataGridInputs, state, createCategoryFaq, updateCategoryFaq, false);
              setReset(!reset);
              return response;
            }}
            header={columns}
            data={data}
            keyProp="key"
            keyValueProp="valueKey"
            titleProp="name"
            editable=""
            actions={actions}
            totalItems={totalItems}
          />
        </>
      )}
    </>
  );
};

export default CategoryFaq;
